<template>
  <div class="page flex-col">
    <div class="group_4 flex-row">
      <div class="section_9 flex-col">
        <div class="image-text_6 flex-col justify-between">
          <img
            class="image_1"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG1ff721e56d7b24d485ed4e0b67ab3695.png"
          />
          <span class="text-group_1">请使用微信扫一扫进行验证</span>
        </div>
        <img
          class="image_2"
          referrerpolicy="no-referrer"
          src="./assets/img/FigmaDDSSlicePNG90f0f164163d362b73e65c44d499cdc8.png"
        />
      </div>
      <img
        class="image_5"
        referrerpolicy="no-referrer"
        src="./assets/img/FigmaDDSSlicePNG267ac6c2f4e3319248e1a88b8e8d9146.png"
      />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="css" src="./assets/index.css" />